export default "__VITE_ASSET__C9dv9qoj__"